.panel {
	background: var(--surface-card);
	border-radius: var(--radius-lg);
	padding: var(--space-5);
	display: flex;
	flex-direction: column;
	gap: var(--space-4);
}

.heading {
	margin: 0;
	font-size: 1rem;
	font-weight: 600;
	color: var(--ink-muted);
	text-transform: uppercase;
	letter-spacing: 0.04em;
}

.field {
	display: flex;
	flex-direction: column;
	gap: var(--space-2);
}

.label {
	font-size: 0.75rem;
	font-weight: 600;
	color: var(--ink-muted);
	text-transform: uppercase;
	letter-spacing: 0.04em;
}

.input {
	width: 100%;
	padding: var(--space-3);
	border: 1px solid color-mix(in srgb, var(--ink) 12%, transparent);
	border-radius: var(--radius-md);
	background: var(--surface-input);
	color: var(--ink);
	font: inherit;
}

.input:focus {
	outline: 2px solid var(--accent-sage);
	outline-offset: 1px;
}

.actions {
	display: flex;
	justify-content: flex-end;
	gap: var(--space-2);
}

.cancel {
	padding: var(--space-2) var(--space-4);
	background: transparent;
	border: 1px solid color-mix(in srgb, var(--ink) 18%, transparent);
	border-radius: var(--radius-md);
	color: var(--ink);
	font: inherit;
	cursor: pointer;
}

.submit {
	padding: var(--space-2) var(--space-4);
	background: var(--accent-sage);
	border: none;
	border-radius: var(--radius-md);
	color: #fff;
	font: inherit;
	font-weight: 600;
	cursor: pointer;
}

.submit:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

.divider {
	display: flex;
	align-items: center;
	gap: var(--space-3);
	color: var(--ink-muted);
	font-size: 0.8rem;
}
.divider::before,
.divider::after {
	content: '';
	flex: 1;
	height: 1px;
	background: color-mix(in srgb, var(--ink) 12%, transparent);
}

.writeOwn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: var(--space-2);
	padding: var(--space-3);
	background: transparent;
	border: 1px solid color-mix(in srgb, var(--ink) 18%, transparent);
	border-radius: var(--radius-md);
	color: var(--ink);
	font: inherit;
	font-weight: 600;
	cursor: pointer;
}
.writeOwn:hover {
	background: var(--surface-input);
}
